<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body>
        <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
          <CommonFieldString
              v-model="storeAggregate.rootData[storeDetail.uidItem].category"
              label="Name"
              class="mt-3"
          ></CommonFieldString>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonFieldString from "@/components/Common/CommonFieldString";

export default {
  name: "CoreCategoryDetail",

  props: {
    uidItem: {default: null},
    storeName: {type: [String], default: 'CategoryDetail'},
    dtoDetailQuery: {default: 'CategoryDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'CategoryActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'CategorySaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'CategoryValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'CategoryBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreCategoryTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonDetail,
    CommonFieldString,
  },

  computed: {},

  methods: {}
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
    }
  }
  ,
}
</script>

<style scoped>

</style>